module.exports = __webpack_public_path__ + "static/media/beaconManageProductQueueHeader.9ef81e49.jpg";